import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {LoginLayoutComponent} from './login-layout.component';
import {EnterPasswordComponent} from './enter-password/enter-password.component';
import {EmailPasswordComponent} from './email-password/email-password.component';
import {CommonSharedModule} from 'common-shared';
import {RouterModule} from '@angular/router';
import {TranslocoModule} from "@jsverse/transloco";
import {InlineSVGModule} from "ng-inline-svg-2";
import {NgbDropdownItem} from "@ng-bootstrap/ng-bootstrap";

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    CommonSharedModule,
    TranslocoModule,
    InlineSVGModule,
    NgbDropdownItem
  ],
  declarations: [
    LoginLayoutComponent,
    EnterPasswordComponent,
    EmailPasswordComponent
  ],
  providers: []
})
export class LoginModule {
}
